module.exports = __webpack_public_path__ + "img/ingamehr-logo.b3069841.svg";